import React, { useEffect, useRef } from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';

import CircularProgress from '@material-ui/core/CircularProgress';

import css from '../nibTable.module.sass';

const TWrapper = ({ infi, children, dataLength, hasMore, next, showTableFooter, scrollableTargetId }) => {
  const wrapperRef = useRef(null);
  const triggerScrollOnTarget = () =>
    document.getElementById(scrollableTargetId || 'app-wrap').dispatchEvent(new CustomEvent('scroll'));
  useEffect(() => {
    if (!wrapperRef.current) return;
    const windowHeight = window.innerHeight;
    const wrapperBottom = wrapperRef.current.getBoundingClientRect().bottom;
    if (windowHeight > wrapperBottom && hasMore) triggerScrollOnTarget();
  });
  if (infi && showTableFooter) {
    return (
      <InfiniteScroll
        dataLength={dataLength}
        next={next}
        hasMore={hasMore}
        loader={
          <div className={css.loader}>
            <CircularProgress color={'primary'} />
          </div>
        }
        endMessage={<h4 className={css.end}>No more data yet</h4>}
        style={{ overflowY: 'auto' }}
        scrollableTarget={scrollableTargetId || 'app-wrap'}
      >
        <div className={css.tableWrap} ref={wrapperRef}>
          {children}
        </div>
      </InfiniteScroll>
    );
  } else {
    return <div className={css.tableWrap}> {children} </div>;
  }
};

export default TWrapper;
